import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@y42/environment';
import { Observable } from 'rxjs';
import { SsoSessionModel } from '../../models/sso-session.model';

@Injectable({
  providedIn: 'root',
})
export class SsoSessionService {
  constructor(private readonly httpService: HttpClient) {}

  getSsoSession(userId: number): Observable<SsoSessionModel> {
    const ssoSessionUrl = `${environment.url.identity_api}/user/${userId}/sso-session-data`;
    return this.httpService.get<SsoSessionModel>(ssoSessionUrl);
  }
}
